// extracted by mini-css-extract-plugin
export var chip = "_mr-2";
export var chipBody = "_mr-8";
export var chipHeader = "_mr-9";
export var chipWithKind = "_mr-7";
export var icon = "_mr-3";
export var kind = "_mr-a";
export var remove = "_mr-5";
export var removeIcon = "_mr-6";
export var row = "_mr-0";
export var rowHistorical = "_mr-1";
export var text = "_mr-4";